
import { mapGetters, mapActions } from "vuex";
import AccountForm from "@/components/venda/AccountForm.vue";
import ContactsForm from "@/components/venda/ContactsForm.vue";
import AddressForm from "@/components/venda/AddressForm.vue";
import DocumentsForm from "@/components/venda/DocumentsForm.vue";
import PaymentInfoForm from "@/components/venda/PaymentInfoForm.vue";
import MembersForm from "@/components/venda/MembersForm.vue";
import checkout from "../../mixins/checkout.mixin.js";

export default {
  name: "NovaVenda",

  mixins: [checkout],

  computed: {
    ...mapGetters("checkout", [
      "PLANO",
      "VALOR_MENSAL",
      "VALOR_INCREMENTAVEL",
      "ASSOCIADOS_LIMITE",
      "DADOS_INTERNOS",
      "CONTRATANTE_TEM_QUE_SER_ASSOCIADO",
    ]),
  },

  methods: {
    ...mapActions("checkout", ["ADICIONA_DADOS_INTERNOS"]),

    persistir() {
      localStorage.setItem(
        "FLEX_venda",
        JSON.stringify({
          account: this.account,
          contacts: this.contacts,
          address: this.address,

          // As imagens não podem ser gravadas no localStorage.
          // Elas permanecem em this.documents enquanto a tela estiver aberta.
          documents: [],

          payment: this.payment,
          members: this.members,
          contratante_associado: this.contratante_associado,
          contratante_plano_dental: this.contratante_plano_dental,
        }),
      );
    },

    obterDaPersistencia() {
      if (
        Object.values(JSON.parse(localStorage.getItem("FLEX_venda"))).length
      ) {
        let data = JSON.parse(localStorage.getItem("FLEX_venda"));
        this.account = data.account;
        this.contacts = data.contacts;
        this.address = data.address;
        this.documents = data.documents;
        this.payment = data.payment;
        this.members = data.members;
        this.contratante_associado = data.contratante_associado;
        this.contratante_plano_dental = data.contratante_plano_dental;
      }
    },

    // Aqui pega tudo e envia pro servidor, o que demora o tempo dos documentos subirem.
    // Uma solução mais inteligente é fazer que nem um método de pagamento.
    // enviar tudo, não tem jeito, e o servidor enviar uma resposta de recebido e em processamento
    // daí via sse ou socket ele informa quando a venda terminar de gravar tudo.
    // isso pode ser feito com um worker externo ao servidor geral.

    async salvarVenda() {
      if (this.sendingData) {
        return;
      }

      this.sendingData = true;
      this.loading("Gravando a Venda. Aguarde um momento");

      const dados_venda = {
        ...this.account,
        ...this.contacts,
        ...this.address,
        ...this.payment,
        valor_adesao: this.valor_adesao,
        contratante_associado: this.contratante_associado,
        contratante_plano_dental: this.contratante_plano_dental,
        ...this.DADOS_INTERNOS,
        associados: this.members,
        documentos: this.documents,
      };

      try {
        await this.$http.post("/venda", dados_venda);

        localStorage.removeItem("FLEX_venda");

        this.$notify.success("A venda foi gravada com sucesso.");

        this.$router.push("/vendas");
      } catch (err) {
        console.error(err);

        this.$notify.error(
          "Houve um erro ao tentar gravar a venda. A venda não foi gravada",
        );
      } finally {
        this.sendingData = false;
        this.$loading(false);
      }
    },
  },

  mounted() {
    // obtem da persistencia caso tenha algo no local storage
    if (localStorage.getItem("FLEX_venda")) {
      if (Object.values(localStorage.getItem("FLEX_venda")).length) {
        this.obterDaPersistencia();
      }
    }

    // Salva a cada segundo
    setInterval(() => {
      this.persistir();
    }, 1000);
  },

  components: {
    AccountForm,
    ContactsForm,
    AddressForm,
    DocumentsForm,
    PaymentInfoForm,
    MembersForm,
  },
};
